(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rx-member-story"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initStories(stories) {
    if (stories.dataset.storiesInit) return;
    stories.dataset.storiesInit = '1';

    const track = stories.querySelector('.rx-stories__track');
    const nav   = stories.querySelector('.rx-stories__nav');
    const dotsC = stories.querySelector('.rx-stories__dots');
    const prev  = stories.querySelector('.rx-stories__prev');
    const next  = stories.querySelector('.rx-stories__next');
    if (!track || !nav) return;

    function pageCount() {
      if (track.scrollWidth <= track.clientWidth + 4) return 1;
      return Math.ceil((track.scrollWidth - track.clientWidth) / track.clientWidth) + 1;
    }
    function getPage() {
      return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
    }
    function buildDots() {
      const n = pageCount();
      nav.hidden = n <= 1;
      if (!dotsC) return;
      dotsC.innerHTML = '';
      for (let i = 0; i < n; i++) {
        const d = document.createElement('button');
        d.type = 'button';
        d.className = 'rx-stories__dot';
        d.setAttribute('role', 'tab');
        d.setAttribute('aria-label', 'Page ' + (i + 1));
        d.addEventListener('click', function() { go(i); });
        dotsC.appendChild(d);
      }
      update();
    }
    function update() {
      const idx = getPage();
      const dots = dotsC ? dotsC.children : [];
      for (let i = 0; i < dots.length; i++) {
        dots[i].setAttribute('aria-selected', i === idx ? 'true' : 'false');
      }
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    }
    function go(idx) {
      const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const max = pageCount() - 1;
      const clamped = Math.max(0, Math.min(idx, max));
      track.scrollTo({ left: clamped * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', function() { go(getPage() - 1); });
    if (next) next.addEventListener('click', function() { go(getPage() + 1); });

    let t;
    track.addEventListener('scroll', function() {
      clearTimeout(t);
      t = setTimeout(update, 100);
    });
    window.addEventListener('resize', function() {
      clearTimeout(t);
      t = setTimeout(buildDots, 200);
    });
    buildDots();
  }

  function initAll(root) {
    const list = (root || document).querySelectorAll('[id^="rx-stories-"]');
    list.forEach(initStories);
  }

  initAll(document);

  document.addEventListener('shopify:section:load', function(e) {
    initAll(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
